module.exports = __webpack_public_path__ + "static/media/social-google.32120882.svg";


//////////////////
// WEBPACK FOOTER
// ./src/img/icons/auth/social-google.svg
// module id = 415
// module chunks = 0